/* North East VAG Adaptions — behaviour for the design layer (no dependencies).
   Ported from the owner's own site: the menu bar that retracts on scroll
   (useHideOnScroll.ts), the hero's typed line (Typewriter.tsx), the vehicle
   finder (VehicleFinder.tsx), the mega menu's rail (MegaMenu.tsx) and the
   contact form's in-page validation (ContactForm.tsx). */
(function () {
  'use strict';

  var root = document.documentElement;
  var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  /* ---------------------------------------------------------------------------
     Menu bar: slides away once the page has scrolled 240px down and comes back
     after 48px of scrolling up, or near the top. Never while a menu, the search
     drawer or a dropdown is open; keyboard focus inside it always brings it back. */
  function initHideOnScroll() {
    var bar = document.getElementById('shopify-section-header');
    if (!bar) return;
    var HIDE_AFTER = 240, SHOW_BELOW = 150, HIDE_BY = 6, SHOW_BY = 48;
    var last = window.pageYOffset;
    var travel = 0;
    var frame = 0;
    var hidden = false;

    function set(value) {
      if (value === hidden) return;
      hidden = value;
      bar.setAttribute('data-nav-hidden', value ? 'true' : 'false');
    }
    function busy() {
      return !!(document.querySelector('.mobile-nav-wrapper.js-menu--is-open') ||
        root.classList.contains('js-drawer-open') ||
        bar.querySelector('.site-nav--active-dropdown'));
    }
    window.addEventListener('scroll', function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        var y = Math.max(window.pageYOffset, 0);
        var step = y - last;
        last = y;
        if (step === 0) return;
        travel = (step > 0) === (travel > 0) ? travel + step : step;
        if (busy() || y < SHOW_BELOW) set(false);
        else if (travel > HIDE_BY && y > HIDE_AFTER) set(true);
        else if (-travel > SHOW_BY) set(false);
      });
    }, { passive: true });
    bar.addEventListener('focusin', function () { set(false); });
  }

  /* ---------------------------------------------------------------------------
     Mega menu: the rail's tabs switch the pane on click, on a resting pointer
     and with the arrow keys. Clicks inside stop here so Debut's dropdown
     script does not read them as a click on the trigger. */
  function initMegaMenus() {
    each(document.querySelectorAll('[data-nev-mega]'), function (mega) {
      var tabs = mega.querySelectorAll('.nev-mega__tab');
      var timer = 0;
      function select(tab, focus) {
        each(tabs, function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var pane = document.getElementById(t.getAttribute('aria-controls'));
          if (pane) pane.hidden = !on;
        });
        if (focus) tab.focus();
      }
      each(tabs, function (tab, index) {
        tab.addEventListener('click', function (event) {
          event.stopPropagation();
          select(tab, false);
        });
        tab.addEventListener('pointerenter', function (event) {
          if (event.pointerType !== 'mouse') return;
          window.clearTimeout(timer);
          timer = window.setTimeout(function () { select(tab, false); }, 90);
        });
        tab.addEventListener('pointerleave', function () { window.clearTimeout(timer); });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowDown') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowUp') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) { event.preventDefault(); select(next, true); }
        });
      });
      mega.addEventListener('click', function (event) {
        if (!event.target.closest('a')) event.stopPropagation();
      });
    });
  }

  /* ---------------------------------------------------------------------------
     The hero's typed line: 85ms per typed character, 45ms per deleted one, a
     1.5s hold on a full word, 260ms before the next. The first word is in the
     HTML; with reduced motion it simply stays. */
  function initTypewriter() {
    each(document.querySelectorAll('[data-nev-typed]'), function (el) {
      var words;
      try { words = JSON.parse(el.getAttribute('data-words') || '[]'); } catch (e) { words = []; }
      if (words.length < 2) return;
      var TYPE_MS = 85, DELETE_MS = 45, HOLD_MS = 1500, GAP_MS = 260;
      var timer = 0, alive = false;

      function stop() {
        alive = false;
        window.clearTimeout(timer);
        el.textContent = words[0];
      }
      function start() {
        if (alive) return;
        alive = true;
        var word = 0, length = words[0].length, deleting = true;
        function tick() {
          if (!alive) return;
          var wait = deleting ? DELETE_MS : TYPE_MS;
          if (deleting) {
            length -= 1;
            if (length <= 0) { length = 0; deleting = false; word = (word + 1) % words.length; wait = GAP_MS; }
          } else {
            length += 1;
            if (length >= words[word].length) { length = words[word].length; deleting = true; wait = HOLD_MS; }
          }
          el.textContent = words[word].slice(0, length) || ' ';
          timer = window.setTimeout(tick, wait);
        }
        timer = window.setTimeout(tick, HOLD_MS);
      }
      if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener('change', function (event) { event.matches ? stop() : start(); });
      }
      if (!reducedMotion.matches) start();
    });
  }

  /* ---------------------------------------------------------------------------
     Vehicle finder: make, then model, then the way into that model's upgrades. */
  function initFinders() {
    each(document.querySelectorAll('[data-nev-finder]'), function (finder) {
      var data;
      try { data = JSON.parse(finder.querySelector('[data-nev-finder-data]').textContent); } catch (e) { return; }
      var makeSelect = finder.querySelector('[data-nev-finder-make]');
      var modelSelect = finder.querySelector('[data-nev-finder-model]');
      var hint = finder.querySelector('[data-nev-finder-hint]');
      var go = finder.querySelector('[data-nev-finder-go]');
      var empty = finder.querySelector('[data-nev-finder-empty]');
      var emptyMake = finder.querySelector('[data-nev-finder-empty-make]');
      if (!makeSelect || !modelSelect) return;

      function modelName(make, title) {
        var prefixes = [make].concat(make === 'Volkswagen' ? ['VW'] : []);
        for (var i = 0; i < prefixes.length; i++) {
          var p = prefixes[i] + ' ';
          if (title.toLowerCase().indexOf(p.toLowerCase()) === 0 && title.length > p.length) return title.slice(p.length);
        }
        return title;
      }
      function option(value, label) {
        var o = document.createElement('option');
        o.value = value;
        o.textContent = label;
        return o;
      }
      function chooseModel() {
        var make = data[makeSelect.value];
        var model = make && make.models[modelSelect.value];
        if (!model) { go.hidden = true; return; }
        var name = modelName(make.name, model.title);
        go.href = model.url;
        go.textContent = model.count > 0
          ? 'See ' + model.count + (model.count === 1 ? ' upgrade' : ' upgrades') + ' for the ' + name
          : 'See upgrades for the ' + name;
        go.hidden = false;
      }
      makeSelect.addEventListener('change', function () {
        var make = data[makeSelect.value];
        modelSelect.innerHTML = '';
        go.hidden = true;
        empty.hidden = true;
        if (!make) {
          modelSelect.appendChild(option('', 'Choose a make first'));
          modelSelect.disabled = true;
          modelSelect.setAttribute('aria-describedby', hint.id);
          hint.hidden = false;
          return;
        }
        hint.hidden = true;
        modelSelect.removeAttribute('aria-describedby');
        if (!make.models.length) {
          modelSelect.appendChild(option('', 'Choose a model'));
          modelSelect.disabled = true;
          if (emptyMake) emptyMake.textContent = make.name;
          empty.hidden = false;
          return;
        }
        modelSelect.appendChild(option('', 'Choose a model'));
        make.models.forEach(function (model, index) {
          modelSelect.appendChild(option(String(index), modelName(make.name, model.title)));
        });
        modelSelect.disabled = false;
      });
      modelSelect.addEventListener('change', chooseModel);
    });
  }

  /* ---------------------------------------------------------------------------
     Contact form: required fields are checked in the page and the reason is
     written under the field, rather than in a browser tooltip that vanishes. */
  function initContactForms() {
    each(document.querySelectorAll('[data-nev-contact-form]'), function (form) {
      form.setAttribute('novalidate', '');
      var fields = form.querySelectorAll('[data-missing]');
      function errorFor(control) { return document.getElementById(control.id + '-error'); }
      function clear(control) {
        var existing = errorFor(control);
        if (existing) existing.remove();
        control.removeAttribute('aria-invalid');
        control.removeAttribute('aria-describedby');
      }
      function show(control, message) {
        clear(control);
        var p = document.createElement('p');
        p.className = 'psp-field-error';
        p.id = control.id + '-error';
        p.textContent = message;
        control.insertAdjacentElement('afterend', p);
        control.setAttribute('aria-invalid', 'true');
        control.setAttribute('aria-describedby', p.id);
      }
      each(fields, function (control) {
        control.addEventListener('input', function () { if (control.getAttribute('aria-invalid')) clear(control); });
      });
      form.addEventListener('submit', function (event) {
        var first = null;
        each(fields, function (control) {
          control.value = control.value.trim() ? control.value : '';
          if (control.validity.valueMissing) show(control, control.getAttribute('data-missing'));
          else if (!control.validity.valid) show(control, control.getAttribute('data-invalid') || control.getAttribute('data-missing'));
          else { clear(control); return; }
          if (!first) first = control;
        });
        if (first) {
          event.preventDefault();
          first.focus();
        }
      });
      var status = form.querySelector('[data-form-status]');
      if (status) {
        window.setTimeout(function () {
          status.scrollIntoView({ block: 'center', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
          status.focus({ preventScroll: true });
        }, 50);
      }
    });
  }

  /* ---------------------------------------------------------------------------
     Product descriptions: "Key Features:" style lines become headings and the
     closing "customers travel from..." paragraph is set apart. */
  function tidyDescriptions() {
    each(document.querySelectorAll('.product-single__description'), function (block) {
      var paras = block.querySelectorAll('p');
      each(paras, function (p) {
        var text = (p.textContent || '').trim();
        var strong = p.querySelector('strong, b');
        if (!strong || !text) return;
        var strongText = (strong.textContent || '').trim();
        if (p.children.length === 1 && strongText === text) {
          if (text.length <= 60 && /:\s*$/.test(text)) {
            p.classList.add('nev-desc-label');
            strong.textContent = strongText.replace(/:\s*$/, '');
          } else if (text.length > 60 && p === paras[paras.length - 1]) {
            p.classList.add('nev-desc-area');
          }
        }
      });
    });
  }

  /* ---------------------------------------------------------------------------
     Lightbox for the work photographs */
  function initLightbox() {
    var triggers = document.querySelectorAll('[data-nev-lightbox]');
    if (!triggers.length || typeof HTMLDialogElement !== 'function') return;

    var dialog = document.createElement('dialog');
    dialog.className = 'nev-lightbox';
    dialog.setAttribute('aria-label', 'Image viewer');
    dialog.innerHTML =
      '<div class="nev-lightbox__inner">' +
      '<button type="button" class="nev-lightbox__close" aria-label="Close">' +
      '<svg class="nev-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      '</button><img alt=""><p class="nev-lightbox__caption"></p></div>';
    document.body.appendChild(dialog);

    var img = dialog.querySelector('img');
    var caption = dialog.querySelector('.nev-lightbox__caption');

    dialog.querySelector('.nev-lightbox__close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { img.removeAttribute('src'); });

    each(triggers, function (trigger) {
      trigger.addEventListener('click', function () {
        img.src = trigger.getAttribute('data-src');
        img.alt = trigger.getAttribute('data-alt') || '';
        caption.textContent = trigger.getAttribute('data-caption') || '';
        caption.hidden = !caption.textContent;
        dialog.showModal();
      });
    });
  }

  /* ---------------------------------------------------------------------------
     Basket drawer (Storefront.tsx): the header basket and Add to basket open the
     <dialog> that sections/nev-cart-drawer.liquid renders. Its contents always
     come from the Section Rendering API, so prices and lines are formatted by
     Shopify; the quantity steppers and remove go through /cart/change.js. */
  function initCartDrawer() {
    var dialog = document.getElementById('NevCartDrawer');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var SECTION = 'nev-cart-drawer';
    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var returnFocus = null;
    var pending = false;

    function wrapper() { return document.getElementById('shopify-section-' + SECTION); }

    function findLine(key) {
      var found = null;
      each(dialog.querySelectorAll('[data-key]'), function (line) { if (line.getAttribute('data-key') === key) found = line; });
      return found;
    }

    function setCount(count) {
      each(document.querySelectorAll('[data-cart-count]'), function (el) { el.textContent = count; });
      each(document.querySelectorAll('[data-cart-count-bubble]'), function (el) { el.classList.toggle('hide', count === 0); });
      each(document.querySelectorAll('[data-nev-cart-open]'), function (el) {
        el.setAttribute('aria-label', 'Basket, ' + count + (count === 1 ? ' item' : ' items'));
      });
    }

    function render(html) {
      var current = wrapper();
      if (!html || !current) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-' + SECTION);
      if (!fresh) return;
      current.innerHTML = fresh.innerHTML;
      var body = current.querySelector('[data-nev-cart-body]');
      if (body) setCount(parseInt(body.getAttribute('data-count'), 10) || 0);
    }

    function status(message) {
      var el = dialog.querySelector('[data-nev-cart-status]');
      if (el) el.textContent = message || '';
    }

    function refresh() {
      return fetch(shopRoot + '?sections=' + SECTION, { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('HTTP ' + response.status); return response.json(); })
        .then(function (data) { render(data[SECTION]); });
    }

    function open(trigger) {
      returnFocus = trigger || document.activeElement;
      if (!dialog.open) {
        dialog.showModal();
        root.classList.add('nev-drawer-open');
      }
      var closeButton = dialog.querySelector('[data-nev-cart-close]');
      if (closeButton) closeButton.focus();
    }

    function close() {
      if (!dialog.open || dialog.hasAttribute('data-closing')) return;
      if (reducedMotion.matches) { dialog.close(); return; }
      dialog.setAttribute('data-closing', '');
      setTimeout(function () { dialog.removeAttribute('data-closing'); dialog.close(); }, 200);
    }

    function change(key, quantity, control) {
      var line = findLine(key);
      var controls = line ? Array.prototype.slice.call(line.querySelectorAll('[data-nev-qty]')) : [];
      var which = controls.indexOf(control);
      pending = true;
      dialog.setAttribute('aria-busy', 'true');
      if (line) line.classList.add('is-updating');
      fetch(shopRoot + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity), sections: [SECTION], sections_url: window.location.pathname })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || '');
            return data;
          });
        })
        .then(function (data) {
          if (data.sections && data.sections[SECTION]) render(data.sections[SECTION]);
          else return refresh();
        })
        .then(function () {
          // The clicked control was replaced: put focus back on its twin, or on close if the line went.
          var again = findLine(key);
          var target = again ? again.querySelectorAll('[data-nev-qty]')[which] : null;
          (target || dialog.querySelector('[data-nev-cart-close]')).focus();
          status(again ? 'Basket updated.' : 'Removed from your basket.');
        })
        .catch(function (error) {
          if (line) line.classList.remove('is-updating');
          status(error && error.message ? error.message : 'We couldn’t update your basket. Please try again.');
        })
        .then(function () {
          pending = false;
          dialog.removeAttribute('aria-busy');
        });
    }

    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('close', function () {
      root.classList.remove('nev-drawer-open');
      status('');
      if (returnFocus && document.body.contains(returnFocus)) returnFocus.focus();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-nev-cart-close]')) { close(); return; }
      var step = event.target.closest('[data-nev-qty]');
      if (!step || pending) return;
      var line = step.closest('[data-key]');
      if (line) change(line.getAttribute('data-key'), parseInt(step.getAttribute('data-nev-qty'), 10), step);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-nev-cart-open]');
      if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (document.body.classList.contains('template-cart')) return;
      event.preventDefault();
      open(trigger);
      refresh().catch(function () {});
    });

    // Debut's product form posts to /cart/add.js and then calls _setupCartPopup
    // with the added line; the drawer takes the place of its popup.
    var Product = window.theme && window.theme.Product;
    if (Product && Product.prototype && Product.prototype._setupCartPopup) {
      Product.prototype._setupCartPopup = function (item) {
        var product = this;
        if (!item || !item.key) {
          product._showErrorMessage((item && (item.description || item.message)) || window.theme.strings.cartError);
          product._handleButtonLoadingState(false);
          return;
        }
        refresh()
          .then(function () {
            product._handleButtonLoadingState(false);
            open(product.addToCart);
            status('Added to your basket.');
            var added = findLine(item.key);
            if (added) {
              added.classList.add('nev-line--added');
              if (added.scrollIntoView) added.scrollIntoView({ block: 'nearest' });
            }
          })
          .catch(function () { window.location.href = shopRoot + 'cart'; });
      };
    }
  }

  /* ---------------------------------------------------------------------------
     Footer: on phones each column folds away behind its title, which becomes a
     button. Wider screens always show every column (the CSS ignores the state). */
  function initFooterFolds(scope) {
    each((scope || document).querySelectorAll('[data-nev-fold]'), function (col) {
      var button = col.querySelector('.nev-footer__fold');
      if (!button || button.hasAttribute('data-bound')) return;
      button.setAttribute('data-bound', '');
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        col.classList.toggle('is-open', expanded);
      });
    });
  }
  document.addEventListener('shopify:section:load', function (event) { initFooterFolds(event.target); });

  /* Header listeners go on straight away: Debut attaches its own dropdown
     handlers on DOMContentLoaded, and the mega menu's must run first. */
  initHideOnScroll();
  initMegaMenus();

  function init() {
    initTypewriter();
    initFinders();
    initContactForms();
    tidyDescriptions();
    initLightbox();
    initCartDrawer();
    initFooterFolds();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
